import React from 'react';

const SummaryCard = ({ stats }) => {
  const totalTags = stats.length;
  const totalSent = stats.reduce((sum, stat) => sum + (parseInt(stat.total_sent) || 0), 0);
  const totalOpened = stats.reduce((sum, stat) => sum + (parseInt(stat.opened_count) || 0), 0);
  const totalResponses = stats.reduce((sum, stat) => sum + (parseInt(stat.total_responses) || 0), 0);
  const totalYes = stats.reduce((sum, stat) => sum + (parseInt(stat.yes_count) || 0), 0);
  const totalNo = stats.reduce((sum, stat) => sum + (parseInt(stat.no_count) || 0), 0);
  const totalRespondents = stats.reduce((sum, stat) => sum + (parseInt(stat.total_respondents) || 0), 0);
  const overallOpenRate = totalSent > 0 ? ((totalOpened / totalSent) * 100).toFixed(1) : 0;

  return (
    <div className="bg-white rounded-lg shadow p-6 mb-6">
      <h2 className="text-2xl font-bold text-gray-900 mb-6">📈 Overall Summary</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="bg-blue-50 rounded-lg p-4">
          <div className="text-3xl font-bold text-blue-600">{totalTags}</div>
          <div className="text-sm text-gray-600 mt-1">Total Campaigns</div>
        </div>
        <div className="bg-green-50 rounded-lg p-4">
          <div className="text-3xl font-bold text-green-600">{totalSent}</div>
          <div className="text-sm text-gray-600 mt-1">Emails Sent</div>
        </div>
        <div className="bg-purple-50 rounded-lg p-4">
          <div className="text-3xl font-bold text-purple-600">{totalOpened}</div>
          <div className="text-sm text-gray-600 mt-1">Emails Opened ({overallOpenRate}%)</div>
        </div>
        <div className="bg-yellow-50 rounded-lg p-4">
          <div className="text-3xl font-bold text-yellow-600">{totalRespondents}</div>
          <div className="text-sm text-gray-600 mt-1">Total Respondents</div>
        </div>
        <div className="bg-pink-50 rounded-lg p-4">
          <div className="text-3xl font-bold text-pink-600">{totalResponses}</div>
          <div className="text-sm text-gray-600 mt-1">Total Responses</div>
        </div>
        <div className="bg-green-100 rounded-lg p-4">
          <div className="text-3xl font-bold text-green-700">{totalYes}</div>
          <div className="text-sm text-gray-600 mt-1">Yes Responses</div>
        </div>
        <div className="bg-red-100 rounded-lg p-4">
          <div className="text-3xl font-bold text-red-700">{totalNo}</div>
          <div className="text-sm text-gray-600 mt-1">No Responses</div>
        </div>
      </div>
    </div>
  );
};

export default SummaryCard;
